"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStaleEntities = exports.queueMutation = exports.optimisticCache = exports.getStaleEntities = exports.dequeueMutation = void 0;
var mutations_queue_1 = require("./mutations-queue");
Object.defineProperty(exports, "dequeueMutation", { enumerable: true, get: function () { return mutations_queue_1.dequeueMutation; } });
Object.defineProperty(exports, "getStaleEntities", { enumerable: true, get: function () { return mutations_queue_1.getStaleEntities; } });
Object.defineProperty(exports, "optimisticCache", { enumerable: true, get: function () { return mutations_queue_1.optimisticCache; } });
Object.defineProperty(exports, "queueMutation", { enumerable: true, get: function () { return mutations_queue_1.queueMutation; } });
Object.defineProperty(exports, "setStaleEntities", { enumerable: true, get: function () { return mutations_queue_1.setStaleEntities; } });
__exportStar(require("./mutations-queue-actions"), exports);
__exportStar(require("./mutations-queue-state"), exports);
__exportStar(require("./send-mutations"), exports);
__exportStar(require("./server-patches"), exports);
//# sourceMappingURL=index.js.map